import tabIcons from './LobbyTabs/images/images';
import otpImages from './OtpVerification/images/images';
import popupImages from './Popups/images/images';

export const pages = {
  LOBBY: 'lobby',
  SALE: 'sale',
};

export const lobbyTabsEnum = {
  PRIVATE: 'private',
  PACKAGEEXISTS: 'packageExists',
  BUSINESSACCOUNT: 'businessAccount',
  BUSINESSINDIVIDUAL: 'businessIndividual',
  PACKAGEEXISTS_BUSINESSINDIVIDUAL: 'packageExistsBusinessIndividual',
  SELFCAREABROAD: 'selfCareAbroad',
};

export const searchParametersEnum = {
  COUNTRY: 'country',
  DATES: 'dates',
};

export const customerTypeEnum = {
  UNKNOWN: 'Unknown',
  PRIVATE: 'Private',
  BUSINESS: 'Business',
};

export const lobbyTabsButtons = [
  {id: lobbyTabsEnum.PRIVATE, title: 'חיפוש חבילה', icon: tabIcons.search, activeIcon: tabIcons.activeSearch},
  {id: lobbyTabsEnum.PACKAGEEXISTS, title: 'יש לי חבילה', icon: tabIcons.packageExists, activeIcon: tabIcons.activePackageExists},
  {id: lobbyTabsEnum.BUSINESSACCOUNT, title: 'מנוי עסקי', icon: tabIcons.businessAccount, activeIcon: tabIcons.activeBusinessAccount},
];

export const lobbyTabsButtonsToSelfCare = [
  {id: lobbyTabsEnum.PRIVATE, title: 'חיפוש חבילה', icon: tabIcons.search, activeIcon: tabIcons.activeSearch},
  {id: lobbyTabsEnum.SELFCAREABROAD, title: 'אזור אישי', icon: tabIcons.packageExists, activeIcon: tabIcons.activePackageExists},
  {id: lobbyTabsEnum.BUSINESSACCOUNT, title: 'מנוי עסקי', icon: tabIcons.businessAccount, activeIcon: tabIcons.activeBusinessAccount},
];

export const lobbyTabsWithoutPackagesButtons = [
  {id: lobbyTabsEnum.PRIVATE, title: 'חיפוש חבילה', icon: tabIcons.search, activeIcon: tabIcons.activeSearch},
  {id: lobbyTabsEnum.BUSINESSACCOUNT, title: 'מנוי עסקי', icon: tabIcons.businessAccount, activeIcon: tabIcons.activeBusinessAccount},
];

export const lobbyTabsButtonsBusinessIndividual = [
  {id: lobbyTabsEnum.BUSINESSINDIVIDUAL, title: 'התקנת חבילת חו”ל', icon: tabIcons.search, activeIcon: tabIcons.activeSearch},
  {
    id: lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL,
    title: 'יש לי חבילה',
    icon: tabIcons.packageExists,
    activeIcon: tabIcons.activePackageExists,
  },
];

export const lobbyTabsButtonsBusinessIndividualWithoutPackagesButtons = [
  {id: lobbyTabsEnum.BUSINESSINDIVIDUAL, title: 'התקנת חבילת חו”ל', icon: tabIcons.search, activeIcon: tabIcons.activeSearch},
];

export const searchPackageItems = [
  {
    id: searchParametersEnum.COUNTRY,
    title: 'לאן טסים?',
    description: 'אפשר לבחור עד חמישה יעדים',
    icon: tabIcons.world,
    activeIcon: tabIcons.smallWorld,
  },
  {
    id: searchParametersEnum.DATES,
    title: 'באיזה תאריכים?',
    description: 'מתאריך ההמראה ועד תאריך הנחיתה',
    icon: tabIcons.calendar,
    activeIcon: tabIcons.smallCalendar,
  },
];

export const otpTitles = {
  regular: {title: '?ומי טס', description: '', codeEnterText: 'קיבלת קוד? אז צריך להזין אותו כאן ולאשר'},
  packageExists: {title: 'ומי טס?', description: 'הזן מס נייד שעליו מותקנת החבילה', codeEnterText: 'קיבלת קוד?'},
  business: {title: 'מנוי עסקי?', description: 'הקלידו כאן את מספר המנוי', codeEnterText: 'שלחנו קוד אימות, הגיע?'},
};

export const createOtpButtonsData = [
  {id: 'sms', alt: `הקוד לא הגיע,<br/> שלחו שוב`, description: `הקוד לא הגיע,<br/> שלחו שוב`, icon: otpImages.sms},
  {id: 'voice', alt: `שלחו את הקוד שוב<br/> בהודעה קולית`, description: `שלחו את הקוד שוב<br/> בהודעה קולית`, icon: otpImages.voice},
];
export const businessIndividualSteps = {
  LOADER: 'loader',
  SELECT_COMPANY: 'select_company',
  SELECT_ACCOUNT: 'select_account',
};

export const saleActiveStep = {
  TICKET: 'ticket',
  LOADER: 'loader',
  COMPLETED_SUCCESSFUL: 'completed_successful',
  COMPLETED_WITH_ERROR: 'completed_with_error',
};

export const saleOTPSteps = {
  MOBILE_INPUT: 'MOBILE INPUT',
  OTP: 'OTP',
  LOADER: 'LOADER',
  STEP_2_VALIDATED: 'STEP_2_VALIDATED',
  AFTER_INPUT: 'AFTER_INPUT',
  SELECT_FAMILY_MEMBER: 'SELECT_FAMILY_MEMBER',
};

// Read brand at access time — module load runs before startPage hydrates Config.setBaseData
const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

export const otpValidationPopupContent = {
  isBusinessAccount: {
    id: 'isBusinessAccount',
    headline: 'יש לנו עסק עם לקוח עסקי',
    get description() {
      return `<span class="bold d-block">${'phoneNumber'}</span> הוא מנוי ${brandNameHe()} עסקי<br />באפשרותך לרכוש חבילה באזור למנוי עסקי`;
    },
    buttonText: 'למעבר לחבילות חו"ל לעסקים',
    icon: popupImages.suitcase,
  },
  isOrgEmployeeFamilyMember: {
    id: 'isOrgEmployeeFamilyMember',
    headline: 'חבילות חו"ל מותאמות במיוחד עבורך',
    get description() {
      return `<span class="bold d-block">${'phoneNumber'}
      </span> <br />מצאנו עבורך חבילות חו"ל ייעודיות לבני משפחות עובדי ${'orgName'}, עם תנאים והטבות מותאמים`;
    },
    buttonText: 'לצפייה בחבילות',
    icon: popupImages.suitcase,
  },
  isBusinessAccountWithPrivateSubscribers: {
    id: 'isBusinessAccountWithPrivateSubscribers',
    headline: 'חבילה זו למנויים פרטיים בלבד',
    get description() {
      return `<span class="bold d-block">${'phoneNumber'}</span> הוא מנוי ${brandNameHe()} עסקי<br />באפשרותך לרכוש חבילה באזור למנוי עסקי`;
    },
    buttonText: 'למעבר לחבילות חו"ל לעסקים',
    textButton: 'אני רוצה לקנות חבילה למנויים פרטיים',
    icon: popupImages.suitcase,
  },
  isPrivateAccount: {
    id: 'isPrivateAccount',
    headline: 'היי, יש פה עניין',
    descriptionBold: `אנחנו רואים ש-${'phoneNumber'} הוא מנוי פרטי`,
    buttonText: 'לחיפוש חבילות פרטיות',
    animated: true,
    icon: popupImages.paperplane,
  },
  isNotGoldAccount: {
    id: 'isNotGoldAccount',
    headline: 'היי, יש פה עניין',
    description: `חבילה מיועדת למנוי זהב בלבד <br /> יש לבחור חבילה אחרת`,
    buttonText: 'לחיפוש חבילות ',
    animated: true,
    icon: popupImages.paperplane,
  },
  isNotRedOrFullFinAccount: {
    id: 'isNotRedOrFullFinAccount',
    headline: 'היי, יש פה עניין',
    description: `חבילה זו אינה חבילה פרטנית לארגונך וניתנת לרכישה ע"י מנוי באופן עצמאי או "דרך מערכת" עסקי באינטרנת`,
    buttonText: 'לחיפוש חבילות ',
    animated: true,
    icon: popupImages.paperplane,
  },
  isBusinessAccountInfo: {
    id: 'isBusinessAccountInfo',
    headline: 'יש לנו עסק עם לקוח עסקי',
    get description() {
      return `<span class="bold d-block">${'phoneNumber'}</span> הוא מנוי ${brandNameHe()} עסקי`;
    },
    buttonText: 'הבנתי',
    icon: popupImages.suitcase,
  },
  isPrivateAccountInfo: {
    id: 'isPrivateAccountInfo',
    headline: 'היי, יש פה עניין',
    descriptionBold: `אנחנו רואים ש-${'phoneNumber'} הוא מנוי פרטי`,
    buttonText: 'לחיפוש חבילות פרטיות',
    animated: true,
    icon: popupImages.paperplane,
  },
  isCellcomWorkerOtpSale: {
    id: 'isCellcomWorkerOtpSale',
    headline: 'תמיד כיף לפגוש קולגות :)',
    get description() {
      return `עובדי ${brandNameHe()} נהנים מ-40% <br/>הנחה על כל החבילות העסקיות`;
    },
    buttonText: 'קחו אותי לשם!',
    icon: popupImages.coconut,
  },
  isCellcomWorkerOtpSaleFamily: {
    id: 'isCellcomWorkerOtpSaleFamily',
    headline: 'תמיד כיף לפגוש קולגות :)',
    get description() {
      return `עובדי ${brandNameHe()} נהנים מ-40% <br/>הנחה על כל החבילות העסקיות`;
    },
    buttonText: 'אוקיי!',
    icon: popupImages.coconut,
  },
  isCellcomWorkerOtpLobby: {
    id: 'isCellcomWorkerOtpLobby',
    headline: 'עובד סלקום יקר',
    description: `בנוסף לעלות החבילה העסקית  האטרקטיבית,<br/>  הינך זכאי ל- 40% הנחה על  החבילה בחשבונית <span class="bold d-block">נסיעה טובה!</span>`,
    buttonText: 'תודה',
    icon: popupImages.coconut,
  },
  isNotCellcomAccount: {
    id: 'isNotCellcomAccount',
    headline: 'אוקיי, זה מוזר',
    get descriptionBold() {
      return `אנחנו לא מזהים את המספר כמנוי ${brandNameHe()}.<br />בדקו את המנוי שהוזן.<br />(4)`;
    },
    buttonText: 'סיום',
    animated: true,
    icon: popupImages.paperplane,
    get gaReportMessageType() {
      return `המספר שהקלדתם הוא לא מנוי ${brandNameHe()}`;
    },
  },
  subStatusIsA: {
    id: 'subStatusIsA',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: 'לצערנו, אי אפשר להוסיף למנוי זה חבילת חו"ל.<br />בדקו את המנוי שהוזן.<br />(3)',
    buttonText: 'סיום',
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: 'לצערנו, אי אפשר להוסיף למנוי זה חבילת חו"ל. בדקו את המנוי שהוזן.',
  },
  dummySubIndIsNull: {
    id: 'dummySubIndIsNull',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold:
      'לצערנו, אי אפשר להוסיף למנוי זה חבילת חו"ל<br />ניתן להוסיף חבילת חו"ל למנוי ראשי בלבד, בדקו את המנוי שהוזן.<br />(1)',
    buttonText: 'סיום',
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: 'לצערנו, אי אפשר להוסיף למנוי זה חבילת חו"ל. ניתן להוסיף חבילת חו"ל למנוי ראשי בלבד, בדקו את המנוי שהוזן.',
  },
  talkmanAccount: {
    id: 'talkmanAccount',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: 'לצערנו, אי אפשר להוסיף למנוי טוקמן חבילת חו"ל.<br />בדקו את המספר שהוזן.<br />(2)',
    buttonText: 'סיום',
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: 'לצערנו, אי אפשר להוסיף למנוי טוקמן חבילת חו"ל. בדקו את המספר שהוזן.',
  },
  autoPackageExists: {
    id: 'autoPackageExists',
    headline: 'רק רגע, יש פה עניין ',
    descriptionBold: `שמנו לב שיש לך חבילת חו"ל שמתחדשת באופן אוטומטי בכל יציאה מהארץ. אין צורך לרכוש חבילה נוספת`,
    description: `לבירורים ושאלות ניתן לפנות לאיש הקשר בארגון שלך`,
    buttonText: 'לחול שלי',
    animated: true,
    icon: popupImages.paperplane,
  },
  autoPackageExistsBusinessIndividual: {
    id: 'autoPackageExistsBusinessIndividual',
    headline: 'רק רגע, יש פה עניין ',
    descriptionBold: `יש למנוי חבילת חו"ל שמתחדשת באופן אוטומטי בכל יציאה מהארץ. אין צורך לרכוש חבילה נוספת`,
    description: `ניתן לרכוש חבילת חו"ל אחרת באמצעות נציג בלבד`,
    buttonText: 'לחול שלי',
    buttonAsLinkText: 'לבחירת מנוי אחר',
    animated: true,
    icon: popupImages.paperplane,
  },
  rollingPackageExists: {
    id: 'rollingPackageExists',
    headline: 'רק רגע, יש פה עניין ',
    descriptionBold: `למנוי קיימת חבילת חו"ל פרטנית,<br/> לא ניתן לרכוש חבילת חו"ל נוספת.`,
    description: `לבירורים נוספים מוזמנים לפנות לאיש הקשר בארגונך`,
    buttonText: 'הבנתי',
    animated: true,
    icon: popupImages.paperplane,
  },
  defaultPackageExists: {
    id: 'defaultPackageExists',
    headline: 'רק רגע,',
    descriptionBold: `קיימת חבילת חו"ל למנוי phoneNumber`,
    buttonText: 'להמשך רכישת החבילה החדשה',
  },
  cantPurchasePackage: {
    id: 'cantPurchasePackage',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `לצערנו, אי אפשר להוסיף למנוי זה חבילת חו"ל`,
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: `אי אפשר להוסיף למנוי זה חבילת חו"ל`,
  },
  abroadIsClosedForAccount: {
    id: 'abroadIsClosedForAccount',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `המנוי פתוח לתקשורת רק בארץ, ולכן אי <br/> אפשר לרכוש עבורו חבילת חו"ל`,
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: `המנוי פתוח לתקשורת רק בארץ, ולכן אי אפשר לרכוש עבורו חבילת חו"ל`,
  },
  abroadIsClosedForAccountSeparatedBank: {
    id: 'abroadIsClosedForAccountSeparatedBank',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `אי אפשר להמשיך לרכישת החבילה, המנוי הזה חסום לגלישה סלולרית.`,
    description: `באפשרותכם לרכוש חבילת שיחות והודעות לפי שימוש, ללא יכולת לגלוש או לפנות לאיש הקשר בחברה שלך להסרת החסימה`,
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: `באפשרותכם לרכוש חבילת שיחות והודעות לפי שימוש, ללא יכולת לגלוש או לפנות לאיש הקשר בחברה שלך להסרת החסימה`,
  },
  abroadIsClosedForAccountSeparatedByUse: {
    id: 'abroadIsClosedForAccountSeparatedByUse',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `המנוי הזה חסום לגלישה סלולרית, ברכישת חבילה זו תוכל להשתמש בה ללא אפשרות גלישה`,
    description: `להסרת החסימה אפשר לפנות לאיש הקשר בחברה שלך`,
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: `המנוי הזה חסום לגלישה סלולרית, ברכישת חבילה זו תוכל להשתמש בה ללא אפשרות גלישה. להסרת החסימה אפשר לפנות לאיש הקשר בחברה שלך.`,
  },
  separatedSaleDefaultPackage: {
    id: `separatedSaleDefaultPackage`,
    headline: `רק רגע, יש פה עניין`,
    descriptionBold: `אי אפשר לרכוש חבילה נוספת כי כבר<br />קיימת חבילת חו"ל למנוי הזה`,
    description: `לבירורים אפשר לפנות לאיש הקשר בחברה שלך`,
    icon: popupImages.paperplane,
    animated: true,
    gaReportMessageType: ``,
  },
  abroadIsClosedForAccountBusinessIndividual: {
    id: 'abroadIsClosedForAccountBusinessIndividual',
    headline: 'רק רגע, יש פה עניין',
    description: `מנוי phoneNumber אינו פתוח לנדידה לחו”ל, <br/> לא ניתן לרכוש עבורו חבילת חו”ל <br/> האם לפתוח את המנוי לנדידה?`,
    animated: true,
    icon: popupImages.paperplane,
    buttonText: 'תפתחו את המנוי לנדידה, אמשיך לרכישת החבילה',
    buttonAsLinkText: `אל תפתחו את המנוי לנדידה לא ארכוש חבילה`,
  },

  separatedSaleRollingPackage: {
    id: `separatedSaleRollingPackage`,
    headline: `רק רגע, יש פה עניין`,
    descriptionBold: `אי אפשר לרכוש חבילה נוספת למנוי כי<br />כבר קיימת לו חבילת חו"ל פרטנית`,
    description: `לבירורים אפשר לפנות לאיש הקשר בחברה שלך`,
    icon: popupImages.paperplane,
    animated: true,
    gaReportMessageType: ``,
  },
  separatedSaleAutoPackage: {
    id: `separatedSaleAutoPackage`,
    headline: `רק רגע, יש פה עניין`,
    descriptionBold: `שמנו לב שיש לך חבילת חו"ל שמתחדשת באופן אוטומטי בכל יציאה מהארץ. אין צורך לרכוש חבילה נוספת`,
    description: `לבירורים ושאלות ניתן לפנות לאיש הקשר בארגון שלך`,
    icon: popupImages.paperplane,
    animated: true,
    gaReportMessageType: ``,
  },
  subsriberSurfIsBlocked: {
    id: 'subsriberSurfIsBlocked',
    headline: 'רק רגע,<br/> לפני שמתקינים את החבילה...',
    descriptionBold: `<span class="d-block bold">אנחנו רואים שבעבר ביקשתם לחסום את הגלישה לחו"ל למספר  phoneNumber</span>`,
    description: 'האם להשאיר את החסימה או להסיר אותה?',
    animated: true,
    icon: popupImages.paperplane,
  },
  subsriberSurfIsBlockedFamilyBundleMultiple: {
    id: 'subsriberSurfIsBlockedFamilyBundleMultiple',
    headline: 'רק רגע,<br/> לפני שמתקינים את החבילה...',
    descriptionBold: `<span class="d-block bold descriptionMultiple">שמנו לב שמוגדרת חסימת <br>גלישה למנויים הבאים</span>`,
    description: 'האם להשאיר את החסימה או להסיר אותה?',
    animated: true,
    icon: popupImages.paperplane,
  },
  subsriberSurfIsBlockedBusinessIndividual: {
    id: 'subsriberSurfIsBlockedBusinessIndividual',
    headline: 'היי מה קורה?',
    description: `ראינו שביקשת בעבר לחסום את הגלישה בחו”ל למנוי -  phoneNumber האם להשאיר את החסימה או להסיר אותה?`,
    animated: true,
    icon: popupImages.paperplane,
    buttonText: `תשאירו את החסימת גלישה בחו”ל והתקינו חבילה`,
    additionalButtonText: `בטלו את החסימת גלישה בחו”ל והתקינו חבילה`,
    buttonAsLinkText: `אל תתקינו חבילה. תנו לי לחשוב.`,
  },
  accountSegmentMatchSoc: {
    id: 'accountSegmentMatchSoc',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `לא ניתן להתקין את החבילה הזאת`,
  },
  separatedNoShadowSoc: {
    id: 'separatedNoShadowSoc',
    headline: 'רק רגע, משהו לא עובד',
    description: 'אי אפשר להשלים את רכישת החבילה.<br />כדאי לנסות לרכוש חבילה אחרת או לפנות למוקד השירות שלנו',
    icon: popupImages.paperplane,
  },
  separatedNoShadowSocCatalogBusinessInd: {
    id: 'separatedNoShadowSocCatalogBusinessInd',
    headline: 'רק רגע, משהו לא עובד',
    description: 'כדי להצטרף לחבילה שבחרת, יש לפנות לאיש הקשר בארגון',
    icon: popupImages.paperplane,
  },
  separatedNoShadowSocTicket: {
    id: 'separatedNoShadowSocTicket',
    headline: 'רק רגע, משהו לא עובד',
    description: 'אי אפשר להשלים את רכישת החבילה.<br />כדאי לנסות לרכוש חבילה אחרת או לפנות למוקד השירות שלנו',
    icon: popupImages.paperplane,
  },
  separatedGeneralError: {
    id: 'separatedGeneralError',
    headline: 'רק רגע, משהו פה לא עבד',
    description: 'אפשר לנסות שוב עוד מספר דקות',
    icon: popupImages.paperplane,
  },
  otpGeneralError: {
    id: 'otpGeneralError',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `לצערנו, לא הצלחנו לזהות את המנוי <br/>נסו שוב במועד מאוחר יותר`,
    animated: true,
    icon: popupImages.paperplane,
    gaReportMessageType: `לצערנו, לא הצלחנו לזהות את המנוי נסו שוב במועד מאוחר יותר`,
  },
  basicGeneralError: {
    id: 'basicGeneralError',
    headline: 'רק רגע, משהו פה לא עבד',
    description: 'אפשר לנסות שוב עוד מספר דקות',
    icon: popupImages.paperplane,
  },
  unableToViewInformation: {
    id: 'unableToViewInformation',
    headline: 'רק רגע, יש פה עניין',
    descriptionBold: `לצערנו, אי אפשר לצפות במידע על מנוי זה`,
    animated: true,
    icon: popupImages.paperplane,
  },
  customerGoldClass: {
    id: 'customerGoldClass',
    headline: 'לידיעתך',
    description: `מדובר במנוי זהב`,
    animated: true,
    icon: popupImages.paperplane,
    buttonText: 'הבנתי',
  },
  pricePlanVoiceExists: {
    id: 'pricePlanVoiceExists',
    headline: 'שים לב',
    description: `<br/> במסגרת תוכנית חיוב קיים תמחור פרטני על שיחות מחול לארץ ,בהתקנת חבילת חול משולבת שיחות ,תמחור השיחות יהיה לפי החבילה המותקנת ולא לפי התמחור הפרטני`,
    animated: true,
    icon: popupImages.paperplane,
    buttonText: 'הבנתי',
  },
  errorOnFetchPackagesBusinessIndividual: {
    id: 'errorOnFetchPackagesBusinessIndividual',
    headline: 'רק רגע, יש פה עניין',
    description: `משהו השתבש ולא הצלחנו לשלוף את החבילות הפרטניות`,
    animated: true,
    icon: popupImages.paperplane,
  },
  addonPurchaseSucceeded: {
    id: 'addonPurchaseSucceeded',
    subTitle: 'איזה כיף!<br/>  הרכישה בוצעה בהצלחה',
    description: 'תוכלו לצפות בפרטי החבילה באיזור חו"ל שלי ',
    icon: popupImages.likeIcon,
    buttonText: 'סיום',
  },
  addonPurchaseFault: {
    id: 'addonPurchaseFault',
    subTitle: 'מצטערים, משהו השתבש והחבילה לא הותקנה',
    icon: popupImages.errorIcon,
    bottomComponent: true,
  },
  showAddonsCancellationNoticePopUp: {
    id: 'showAddonsCancellationNoticePopUp',
    subTitle: 'חשוב לנו שתדעו',
    description: ' ביטול חבילת החו"ל שברשותך תבטל גם את תוספת החבילות שנרכשו לחבילה זו: ',
    icon: popupImages.likeIcon,
    buttonText: 'הבנתי, תודה',
  },
  removeCapSocProcessLoading: {
    id: 'removeCapSocProcessLoading',
  },
  removeCapSocProcessSuccess: {
    id: 'removeCapSocProcessSuccess',
    headline: 'תקרת החיוב הוסרה בהצלחה',
    icon: require('./images/icon-success.svg'),
    buttonText: 'סיום',
  },
  removeCapSocProcessError: {
    id: 'removeCapSocProcessError',
    headline: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    icon: require('./images/icon-alert.svg'),
    buttonText: 'הבנתי, תודה',
  },
};

export const popupReasonEnum = {
  ERROR_MESSAGE: 'errorMessage',
  LIMIT_COUNTRIES_COUNT_ON_SELECT: 'limitCountriesCountOnSelect',
  COUNTRY_WARNING_INFO: 'countryWarningInfo',
  CONNECTED_COUNTRY_EXISTS: 'connectedCountryExists',
  SELECTED_COUNTRY_IS_NOT_SUPPORTED_IN_SELECTED_PACKAGE: 'selectedCountryIsNotSupportedInSelectedPackage',
  ALL_SELECTED_COUNTRIES_ARE_NOT_SUPPORTED_IN_SELECTED_PACKAGE: 'allSelectedCountriesAreNotSupportedInSelectedPackage',
  SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE: 'selectedDatesAreNotSuitableForSelectedPackage',
  OTP_RESULT: 'otpResult',
  CHANGE_PACKAGE_START_DAY: 'changePackageStartDay',
  DISPLAY_INFO_FAMILY: 'displayInfoFamily',
  DISPLAY_INFO_FAMILY_BUNDLE: 'displayInfoFamilyBundle',
  DATA_USAGE_IS_BLOCKED: 'dataUsageIsBlocked',
  ACCOUNT_SEGMENT_MATCH_SOC: 'accountSegmentMatchSoc',
  STATE_SUPPORTED: 'stateSupported',
  ADDON_PURCHASE_RESULT: 'addonPurchaseResult',
  IDF_ORDER: 'idfOrder',
  ENABLE_INDEPENDENT_PURCHASE: 'enableIndependentPurchase',
  BUY_WITH_ORG: 'buyWithOrg',
  BUY_WITH_ORG_TICKET: 'buyWithOrgTicket',
  FAILED_SURF_BLOCK_REMOVE: 'failedSurfBlockRemove',
  RESTRICTED_CODE_REQUIRED: 'restrictedCodeRequired',
  CAP_SOC: 'capSoc',
  CAP_SOC_REMOVE_PROCESSING: 'capSocRemoveProcessing',
  SELECT_FAMILY_MEMBERS: 'selectFamilyMembers',
  NO_MEMBERS_SELECTED: 'noMembersSelected',
  FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR: 'familyBundleFlightManagerError',
  FAMILY_BUNDLE_FLIGHT_MEMBERS_ERROR: 'familyBundleFlightMembersError',
  FAMILY_BUNDLE_CELLULAR_DATA_OFF: 'familyBundleCellularDataOff',
  FAMILY_BUNDLE_HAS_SOC: 'familyBundleHasSoc',
};

export const toolTipFamily = `
אפשר לצרף לחבילה מנויים המשוייכים לאותה ת.ז ומשולמים מאותו אמצעי תשלום
<br/>
החבילה יכולה להתחיל עד שבעה ימים אחרי החבילה הראשית
<br/>
החבילה לא יכולה להתחיל לפני שהחבילה הראשית מתחילה
<br/>
חשוב לדעת: החבילה המשפחתית תקפה לאותם יעדים של החבילה הראשית
`;
